import { useTranslation } from 'react-i18next';

export const getTableColumns = () => {
    const { t } = useTranslation();
    
    return [
        {
            key: 'source',
            header: t('source'),
            maxWidth: true,
            render: (item) => (
                <div className="break-all">
                    <a 
                        href={item.source} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800 hover:underline truncate block"
                        title={item.source}
                    >
                        {item.source}
                    </a>
                </div>
            )
        },
        {
            key: 'city',
            header: t('city')
        },
        {
            key: 'category',
            header: t('category')
        },
        {
            key: 'status',
            header: t('status'),
            render: (item) => {
                // Map status values to translation keys and colors
                const statusMap = {
                    'Processing': { key: 'processing', color: 'bg-yellow-500' },
                    'DataScraped': { key: 'datascraped', color: 'bg-pink-500' },
                    'Success': { key: 'success', color: 'bg-green-500' },
                    'Error': { key: 'error', color: 'bg-red-500' },
                };
                
                const statusConfig = statusMap[item.status] || { 
                    key: item.status.toLowerCase(), 
                    color: 'bg-gray-500' 
                };
                
                return (
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-white ${statusConfig.color}`}>
                        {t(statusConfig.key)}
                    </span>
                );
            }
        },
        {
            key: 'createdAt',
            header: t('createdAt'),

            render: (item) => {
                // Map status values to translation keys
              const translationKey = new Date(item.createdAt).toLocaleString("de", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit"
                            })
                
                return translationKey;
            }
        }
    ];
};

